/**
 path: src/utils/htmlToPdf.js
 name: 导出页面为PDF格式
 **/
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

const htmlToPdf = {
  pdfExport() {
    let mainRight = document.getElementById('pdfDom');
    html2Canvas(mainRight, {
       allowTaint: true,
       scale: 2, // 提升画面质量，但是会增加文件大小
    }).then(function(canvas) {
      let contentWidth = canvas.width;
      let contentHeight = canvas.height;

      let pageData = canvas.toDataURL('image/jpeg', 0.4);

      let pdfWidth = (contentWidth + 10) / 2 * 0.75;
      let pdfHeight = (contentHeight + 200) / 2 * 0.75; // 500为底部留白

      let imgWidth = pdfWidth;
      let imgHeight = (contentHeight / 2 * 0.75); //内容图片这里不需要留白的距离

      let pdf = new JsPDF('', 'pt', [pdfWidth, pdfHeight]);
      pdf.addImage(pageData, 'jpeg', 0, 0, imgWidth, imgHeight);
      pdf.save('report_pdf_' + new Date().getTime() + '.pdf');
    });
  },
  getPdf(title) {
    html2Canvas(document.querySelector('#pdfDom'), {
      allowTaint: true,
    }).then(canvas=>{
      //内容的宽度
      let contentWidth = canvas.width;
      //内容高度
      let contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度,a4纸的尺寸[595.28,841.89];
      let pageHeight = contentWidth / 592.28 * 841.89;
      //未生成pdf的html页面高度
      let leftHeight = contentHeight;
      //页面偏移
      let position = 0;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      let imgWidth = 595.28;
      let imgHeight = 841.89 / contentWidth * contentHeight;
      // let imgHeight = 592.28 / contentWidth * contentHeight;
      //canvas转图片数据
      let pageData = canvas.toDataURL('image/jpeg', 1.0);
      //新建JsPDF对象
      let PDF = new JsPDF('', 'pt', 'a4');
      //判断是否分页
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        while (leftHeight > 0) {
          PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          if (leftHeight > 0) {
            PDF.addPage()
          }
        }
      }
      //保存文件
      PDF.save(title + '.pdf')


      /*********************************手机端使用******************************/
      /*var _this=this
      //转成base64
      let pdf64 = PDF.output("datauristring");
      //base64转成blob文件
      let path = _this.createDownloadFile("报表", pdf64);
      //上传到服务器
      let formdata = new FormData();
      //第三个参数传一个不一定会用到的文件名，但是得有。注意后缀
      formdata.append("file", path, "报表.pdf");
      //调上传接口，这里因为我封装了axios增加了拦截器，所以是下面的写法，这里根据各位的上传方法不同，自行修改
      request({
        url: _this.url + _this.curVersion + "/SysFile/uploadImg",
        method: "post",
        data: formdata,
      }).then((res) => {
        //拼接文件线上地址
        let path =
          _this.url + res.data.data.filePath + res.data.data.fileName;
        //调用安卓或者ios提供的方法，打开浏览器
        Android.openBrowser(path);
      });*/
      /*******************------------------------********************/
    })
  }
};

export default htmlToPdf;



// WEBPACK FOOTER //
// ./src/utils/htmlToPdf.js